import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { DateRange } from '@angular/material/datepicker';

@Component({
  selector: 'app-calendar-modal',
  templateUrl: './calendar-modal.component.html',
  styleUrls: ['./calendar-modal.component.scss'],
})
export class CalendarModalComponent implements OnInit {
  theme: string = '';

  calendarSimpleSelect: boolean = false;
  calendarStartEndDate: boolean = false;

  // Range calendar state
  selectedRange: DateRange<Date> = new DateRange<Date>(null, null);
  private rangeStart: Date | undefined;

  // Simple calendar state
  selectedSimpleDate: Date | null = null;

  // Opcional (calendario simple): primer día que se puede elegir; los anteriores quedan deshabilitados.
  minDate: Date | null = null;

  // Display strings (DD/MM/YYYY)
  startDate: string = '';
  endDate: string = '';
  selectedDate: string = '';

  constructor(
    public modalController: ModalController,
    private navParams: NavParams,
  ) {}

  ngOnInit() {
    const typeCalendar = this.navParams.get('typeCalendar');
    const themeModule = this.navParams.get('themeModule');

    if (typeCalendar === 'rangeCalendar') {
      this.calendarStartEndDate = true;
      this.calendarSimpleSelect = false;
    }
    if (typeCalendar === 'simpleCalendar') {
      this.calendarStartEndDate = false;
      this.calendarSimpleSelect = true;
    }

    if (themeModule === 'Cursalab') this.theme = 'Cursalab';
    if (themeModule === 'IR') this.theme = 'IR';

    // Opcional: primer día elegible (p. ej. agendar solo de hoy en adelante).
    const minDate: Date | null = this.navParams.get('minDate');
    if (this.calendarSimpleSelect && minDate instanceof Date && !isNaN(minDate.getTime())) {
      this.minDate = minDate;
    }

    // Opcional: fecha ya elegida (edición), para abrir el calendario posicionado en ella.
    const initialDate: Date | null = this.navParams.get('initialDate');
    if (this.calendarSimpleSelect && initialDate instanceof Date && !isNaN(initialDate.getTime())) {
      this.selectedSimpleDate = initialDate;
      this.selectedDate = this.toDisplayDate(initialDate);
    }
  }

  onRangeDateSelected(date: Date) {
    if (!this.rangeStart) {
      this.rangeStart = date;
      this.selectedRange = new DateRange<Date>(date, null);
      this.startDate = this.toDisplayDate(date);
      this.endDate = '';
    } else {
      const start = date >= this.rangeStart ? this.rangeStart : date;
      const end = date >= this.rangeStart ? date : this.rangeStart;
      this.selectedRange = new DateRange<Date>(start, end);
      this.startDate = this.toDisplayDate(start);
      this.endDate = this.toDisplayDate(end);
      this.rangeStart = undefined;
    }
  }

  onSimpleDateSelected(date: Date) {
    this.selectedSimpleDate = date;
    this.selectedDate = this.toDisplayDate(date);
  }

  private toDisplayDate(date: Date): string {
    const d = date.getDate().toString().padStart(2, '0');
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }

  close() {
    this.modalController.dismiss();
  }

  saveRange() {
    const dates = {
      start: this.startDate,
      end: this.endDate,
    };
    this.modalController.dismiss({ range: dates });
  }

  saveSimpleDate() {
    this.modalController.dismiss({ date: this.selectedDate });
  }
}
